export default class DeploymentForbiddanceReason {
	static NONE = 'NONE';
	static CONTAINER_IS_NOT_ASSIGNED = 'CONTAINER_IS_NOT_ASSIGNED';
	static CONTAINER_IS_NOT_ACTIVE = 'CONTAINER_IS_NOT_ACTIVE';
  static APPLICATION_IS_NOT_ACTIVE = 'APPLICATION_IS_NOT_ACTIVE';
	static USER_IS_NOT_CONTRIBUTOR = 'USER_IS_NOT_CONTRIBUTOR';
  static USER_IS_NOT_ALLOWED = 'USER_IS_NOT_ALLOWED';
}
